// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dark .paylixecommerce-notification {
  background: rgba(15, 23, 42, 0.95);
  border-color: rgba(71, 85, 105, 0.4);
}
.dark .paylixecommerce-notification.info {
  background: rgba(88, 28, 135, 0.15);
  border-color: rgba(139, 92, 246, 0.3);
}
.dark .paylixecommerce-notification.info .paylixecommerce-notification-icon {
  background: rgba(88, 28, 135, 0.2);
}
.dark .paylixecommerce-notification.info .paylixecommerce-notification-icon svg {
  color: #C4B5FD !important;
}
.dark .paylixecommerce-notification.info .paylixecommerce-notification-icon svg * {
  stroke: #C4B5FD !important;
}
.dark .paylixecommerce-notification.info .paylixecommerce-notification-title {
  color: #E2E8F0;
}
.dark .paylixecommerce-notification.info .paylixecommerce-notification-message {
  color: #CBD5E1;
}
.dark .paylixecommerce-notification.success {
  background: rgba(5, 150, 105, 0.15);
  border-color: rgba(34, 197, 94, 0.3);
}
.dark .paylixecommerce-notification.success .paylixecommerce-notification-icon {
  background: rgba(5, 150, 105, 0.2);
}
.dark .paylixecommerce-notification.success .paylixecommerce-notification-icon svg {
  color: #6EE7B7 !important;
}
.dark .paylixecommerce-notification.success .paylixecommerce-notification-icon svg * {
  stroke: #6EE7B7 !important;
}
.dark .paylixecommerce-notification.success .paylixecommerce-notification-title {
  color: #E2E8F0;
}
.dark .paylixecommerce-notification.success .paylixecommerce-notification-message {
  color: #CBD5E1;
}
.dark .paylixecommerce-notification.warning {
  background: rgba(249, 115, 22, 0.15);
  border-color: rgba(251, 146, 60, 0.3);
}
.dark .paylixecommerce-notification.warning .paylixecommerce-notification-icon {
  background: rgba(249, 115, 22, 0.2);
}
.dark .paylixecommerce-notification.warning .paylixecommerce-notification-icon svg {
  color: #FDBA74 !important;
}
.dark .paylixecommerce-notification.warning .paylixecommerce-notification-icon svg * {
  stroke: #FDBA74 !important;
}
.dark .paylixecommerce-notification.warning .paylixecommerce-notification-title {
  color: #E2E8F0;
}
.dark .paylixecommerce-notification.warning .paylixecommerce-notification-message {
  color: #CBD5E1;
}
.dark .paylixecommerce-notification.error {
  background: rgba(220, 38, 38, 0.15);
  border-color: rgba(248, 113, 113, 0.3);
}
.dark .paylixecommerce-notification.error .paylixecommerce-notification-icon {
  background: rgba(220, 38, 38, 0.2);
}
.dark .paylixecommerce-notification.error .paylixecommerce-notification-icon svg {
  color: #FECACA !important;
}
.dark .paylixecommerce-notification.error .paylixecommerce-notification-icon svg * {
  stroke: #FECACA !important;
}
.dark .paylixecommerce-notification.error .paylixecommerce-notification-title {
  color: #E2E8F0;
}
.dark .paylixecommerce-notification.error .paylixecommerce-notification-message {
  color: #CBD5E1;
}
.dark .paylixecommerce-notification .paylixecommerce-notification-close {
  color: #94A3B8;
}
.dark .paylixecommerce-notification .paylixecommerce-notification-close:hover {
  background: rgba(71, 85, 105, 0.2);
  color: #E2E8F0;
}
.dark .paylixecommerce-notification .paylixecommerce-notification-close:focus {
  box-shadow: 0 0 0 2px rgba(139, 92, 246, 0.5);
}

.paylixecommerce-notification {
  position: relative;
  background: var(--white);
  border: 1px solid var(--black2);
  border-radius: 0.75rem;
  box-shadow: 0px 4px 8px -2px rgba(7, 14, 35, 0.08), 0px 2px 4px -2px rgba(7, 14, 35, 0.03);
  font-family: "Inter", sans-serif;
  font-style: normal;
  overflow: hidden;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  max-width: 100%;
}
@media (max-width: 768px) {
  .paylixecommerce-notification {
    border-radius: 0.5rem;
    margin: 0 0.5rem;
  }
}
.paylixecommerce-notification:hover {
  box-shadow: 0px 8px 16px -4px rgba(7, 14, 35, 0.12), 0px 4px 8px -4px rgba(7, 14, 35, 0.06);
}
.paylixecommerce-notification.no-hover:hover {
  box-shadow: 0px 4px 8px -2px rgba(7, 14, 35, 0.08), 0px 2px 4px -2px rgba(7, 14, 35, 0.03);
}
.paylixecommerce-notification.info {
  background: var(--purple0);
  border-color: var(--purple2);
}
.paylixecommerce-notification.info .paylixecommerce-notification-icon {
  background: var(--purple1);
}
.paylixecommerce-notification.info .paylixecommerce-notification-icon svg * {
  stroke: var(--purple6);
}
.paylixecommerce-notification.info .paylixecommerce-notification-title {
  color: var(--purple9);
}
.paylixecommerce-notification.info .paylixecommerce-notification-message {
  color: var(--purple7);
}
.paylixecommerce-notification.success {
  background: var(--green0);
  border-color: var(--green2);
}
.paylixecommerce-notification.success .paylixecommerce-notification-icon {
  background: var(--green1);
}
.paylixecommerce-notification.success .paylixecommerce-notification-icon svg * {
  stroke: var(--green6);
}
.paylixecommerce-notification.success .paylixecommerce-notification-title {
  color: var(--green9);
}
.paylixecommerce-notification.success .paylixecommerce-notification-message {
  color: var(--green7);
}
.paylixecommerce-notification.warning {
  background: var(--orange0);
  border-color: var(--orange2);
}
.paylixecommerce-notification.warning .paylixecommerce-notification-icon {
  background: var(--orange1);
}
.paylixecommerce-notification.warning .paylixecommerce-notification-icon svg * {
  stroke: var(--orange6);
}
.paylixecommerce-notification.warning .paylixecommerce-notification-title {
  color: var(--orange9);
}
.paylixecommerce-notification.warning .paylixecommerce-notification-message {
  color: var(--orange7);
}
.paylixecommerce-notification.error {
  background: var(--red0);
  border-color: var(--red2);
}
.paylixecommerce-notification.error .paylixecommerce-notification-icon {
  background: var(--red1);
}
.paylixecommerce-notification.error .paylixecommerce-notification-icon svg * {
  stroke: var(--red6);
}
.paylixecommerce-notification.error .paylixecommerce-notification-title {
  color: var(--red9);
}
.paylixecommerce-notification.error .paylixecommerce-notification-message {
  color: var(--red7);
}
.paylixecommerce-notification-content {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 1rem;
}
@media (max-width: 768px) {
  .paylixecommerce-notification-content {
    gap: 0.5rem;
    padding: 0.875rem;
  }
}
.paylixecommerce-notification-icon {
  flex-shrink: 0;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--purple1);
}
@media (max-width: 768px) {
  .paylixecommerce-notification-icon {
    width: 2.25rem;
    height: 2.25rem;
  }
}
.paylixecommerce-notification-icon svg {
  width: 1.125rem;
  height: 1.125rem;
}
@media (max-width: 768px) {
  .paylixecommerce-notification-icon svg {
    width: 1rem;
    height: 1rem;
  }
}
.paylixecommerce-notification-body {
  flex: 1;
  min-width: 0;
}
.paylixecommerce-notification-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 0.25rem;
  gap: 1rem;
}
.paylixecommerce-notification-title {
  font-weight: 600;
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: var(--black9);
  margin: 0;
  flex: 1;
}
@media (max-width: 768px) {
  .paylixecommerce-notification-title {
    font-size: 0.813rem;
    line-height: 1.125rem;
  }
}
.paylixecommerce-notification-close {
  flex-shrink: 0;
  background: transparent;
  border: none;
  padding: 0.125rem;
  border-radius: 0.25rem;
  cursor: pointer;
  color: var(--black4);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease-in-out;
}
.paylixecommerce-notification-close:hover {
  background: var(--black1);
  color: var(--black6);
}
.paylixecommerce-notification-close:focus {
  outline: none;
  box-shadow: 0 0 0 2px var(--purple2);
}
.paylixecommerce-notification-close svg {
  width: 1rem;
  height: 1rem;
}
.paylixecommerce-notification-message {
  font-weight: 400;
  font-size: 0.813rem;
  line-height: 1.125rem;
  color: var(--black6);
  margin: 0 0 0.75rem 0;
}
@media (max-width: 768px) {
  .paylixecommerce-notification-message {
    font-size: 0.75rem;
    line-height: 1rem;
    margin-bottom: 0.5rem;
  }
}
.paylixecommerce-notification-message:last-child {
  margin-bottom: 0;
}
.paylixecommerce-notification-children {
  margin: 0.75rem 0 0 0;
}
@media (max-width: 768px) {
  .paylixecommerce-notification-children {
    margin-top: 0.5rem;
  }
}
.paylixecommerce-notification-children:last-child {
  margin-bottom: 0;
}
.paylixecommerce-notification-actions {
  display: flex;
  gap: 0.5rem;
  margin-top: 0.75rem;
  flex-wrap: wrap;
}
@media (max-width: 768px) {
  .paylixecommerce-notification-actions {
    margin-top: 0.5rem;
    gap: 0.375rem;
  }
}
.paylixecommerce-notification-actions button {
  font-size: 0.75rem;
}
@media (max-width: 768px) {
  .paylixecommerce-notification-actions button {
    font-size: 0.688rem;
  }
}

.paylixecommerce-notification-toast {
  position: fixed;
  z-index: 9999;
  pointer-events: none;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  max-width: 420px;
  width: 100%;
}
@media (max-width: 768px) {
  .paylixecommerce-notification-toast {
    max-width: calc(100% - 1rem);
    gap: 0.5rem;
  }
}
.paylixecommerce-notification-toast .paylixecommerce-notification {
  pointer-events: auto;
  animation: slideIn 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}
.paylixecommerce-notification-toast.top-right {
  top: 1rem;
  right: 1rem;
}
@media (max-width: 768px) {
  .paylixecommerce-notification-toast.top-right {
    top: 0.75rem;
    right: 0.5rem;
    left: 0.5rem;
    max-width: none;
  }
}
.paylixecommerce-notification-toast.top-left {
  top: 1rem;
  left: 1rem;
}
@media (max-width: 768px) {
  .paylixecommerce-notification-toast.top-left {
    top: 0.75rem;
    right: 0.5rem;
    left: 0.5rem;
    max-width: none;
  }
}
.paylixecommerce-notification-toast.top-center {
  top: 1rem;
  left: 50%;
  transform: translateX(-50%);
}
@media (max-width: 768px) {
  .paylixecommerce-notification-toast.top-center {
    top: 0.75rem;
    right: 0.5rem;
    left: 0.5rem;
    transform: none;
    max-width: none;
  }
}
.paylixecommerce-notification-toast.bottom-right {
  bottom: 1rem;
  right: 1rem;
}
@media (max-width: 768px) {
  .paylixecommerce-notification-toast.bottom-right {
    bottom: 0.75rem;
    right: 0.5rem;
    left: 0.5rem;
    max-width: none;
  }
}
.paylixecommerce-notification-toast.bottom-left {
  bottom: 1rem;
  left: 1rem;
}
@media (max-width: 768px) {
  .paylixecommerce-notification-toast.bottom-left {
    bottom: 0.75rem;
    right: 0.5rem;
    left: 0.5rem;
    max-width: none;
  }
}
.paylixecommerce-notification-toast.bottom-center {
  bottom: 1rem;
  left: 50%;
  transform: translateX(-50%);
}
@media (max-width: 768px) {
  .paylixecommerce-notification-toast.bottom-center {
    bottom: 0.75rem;
    right: 0.5rem;
    left: 0.5rem;
    transform: none;
    max-width: none;
  }
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-0.5rem);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
html .paylixecommerce-notification {
  --green9: #065F46;
  --green8: #047857;
  --green7: #059669;
  --green6: #10B981;
  --green5: #34D399;
  --green4: #6EE7B7;
  --green3: #A7F3D0;
  --green2: #D1FAE5;
  --green1: #ECFDF5;
  --green0: #F0FDF4;
  --orange9: #9A3412;
  --orange8: #C2410C;
  --orange7: #EA580C;
  --orange6: #F97316;
  --orange5: #FB923C;
  --orange4: #FDBA74;
  --orange3: #FED7AA;
  --orange2: #FEEBC8;
  --orange1: #FEF3E2;
  --orange0: #FFFBEB;
  --red9: #991B1B;
  --red8: #DC2626;
  --red7: #EF4444;
  --red6: #F87171;
  --red5: #FCA5A5;
  --red4: #FECACA;
  --red3: #FEE2E2;
  --red2: #FEEAEA;
  --red1: #FEF2F2;
  --red0: #FEF7F7;
}`, "",{"version":3,"sources":["webpack://./client/components/notification/style.scss"],"names":[],"mappings":"AACA;EACE,kCAAA;EACA,oCAAA;AAAF;AAEE;EACE,mCAAA;EACA,qCAAA;AAAJ;AAEI;EACE,kCAAA;AAAN;AACM;EACE,yBAAA;AACR;AACQ;EACE,0BAAA;AACV;AAII;EACE,cAAA;AAFN;AAKI;EACE,cAAA;AAHN;AAOE;EACE,mCAAA;EACA,oCAAA;AALJ;AAOI;EACE,kCAAA;AALN;AAMM;EACE,yBAAA;AAJR;AAMQ;EACE,0BAAA;AAJV;AASI;EACE,cAAA;AAPN;AAUI;EACE,cAAA;AARN;AAYE;EACE,oCAAA;EACA,qCAAA;AAVJ;AAYI;EACE,mCAAA;AAVN;AAWM;EACE,yBAAA;AATR;AAWQ;EACE,0BAAA;AATV;AAcI;EACE,cAAA;AAZN;AAeI;EACE,cAAA;AAbN;AAiBE;EACE,mCAAA;EACA,sCAAA;AAfJ;AAiBI;EACE,kCAAA;AAfN;AAgBM;EACE,yBAAA;AAdR;AAgBQ;EACE,0BAAA;AAdV;AAmBI;EACE,cAAA;AAjBN;AAoBI;EACE,cAAA;AAlBN;AAuBE;EACE,cAAA;AArBJ;AAuBI;EACE,kCAAA;EACA,cAAA;AArBN;AAwBI;EACE,6CAAA;AAtBN;;AA4BA;EACE,kBAAA;EACA,wBAAA;EACA,+BAAA;EACA,sBAAA;EACA,0FAAA;EACA,gCAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;EACA,eAAA;AAzBF;AA2BE;EAZF;IAaI,qBAAA;IACA,gBAAA;EAxBF;AACF;AA0BE;EACE,2FAAA;AAxBJ;AA4BE;EACE,0FAAA;AA1BJ;AA8BE;EACE,0BAAA;EACA,4BAAA;AA5BJ;AA8BI;EACE,0BAAA;AA5BN;AA6BM;EACE,sBAAA;AA3BR;AA+BI;EACE,qBAAA;AA7BN;AAgCI;EACE,qBAAA;AA9BN;AAkCE;EACE,yBAAA;EACA,2BAAA;AAhCJ;AAkCI;EACE,yBAAA;AAhCN;AAiCM;EACE,qBAAA;AA/BR;AAmCI;EACE,oBAAA;AAjCN;AAoCI;EACE,oBAAA;AAlCN;AAsCE;EACE,0BAAA;EACA,4BAAA;AApCJ;AAsCI;EACE,0BAAA;AApCN;AAqCM;EACE,sBAAA;AAnCR;AAuCI;EACE,qBAAA;AArCN;AAwCI;EACE,qBAAA;AAtCN;AA0CE;EACE,uBAAA;EACA,yBAAA;AAxCJ;AA0CI;EACE,uBAAA;AAxCN;AAyCM;EACE,mBAAA;AAvCR;AA2CI;EACE,kBAAA;AAzCN;AA4CI;EACE,kBAAA;AA1CN;AA8CE;EACE,aAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;AA5CJ;AA8CI;EANF;IAOI,WAAA;IACA,iBAAA;EA3CJ;AACF;AA8CE;EACE,cAAA;EACA,aAAA;EACA,cAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,0BAAA;AA5CJ;AA8CI;EAVF;IAWI,cAAA;IACA,eAAA;EA3CJ;AACF;AA6CI;EACE,eAAA;EACA,gBAAA;AA3CN;AA6CM;EAJF;IAKI,WAAA;IACA,YAAA;EA1CN;AACF;AA8CE;EACE,OAAA;EACA,YAAA;AA5CJ;AA+CE;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,sBAAA;EACA,SAAA;AA7CJ;AAgDE;EACE,gBAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;EACA,SAAA;EACA,OAAA;AA9CJ;AAgDI;EARF;IASI,mBAAA;IACA,qBAAA;EA7CJ;AACF;AAgDE;EACE,cAAA;EACA,uBAAA;EACA,YAAA;EACA,iBAAA;EACA,sBAAA;EACA,eAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iCAAA;AA9CJ;AAgDI;EACE,yBAAA;EACA,oBAAA;AA9CN;AAiDI;EACE,aAAA;EACA,oCAAA;AA/CN;AAkDI;EACE,WAAA;EACA,YAAA;AAhDN;AAoDE;EACE,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,oBAAA;EACA,qBAAA;AAlDJ;AAoDI;EAPF;IAQI,kBAAA;IACA,iBAAA;IACA,qBAAA;EAjDJ;AACF;AAmDI;EACE,gBAAA;AAjDN;AAqDE;EACE,qBAAA;AAnDJ;AAqDI;EAHF;IAII,kBAAA;EAlDJ;AACF;AAoDI;EACE,gBAAA;AAlDN;AAsDE;EACE,aAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;AApDJ;AAsDI;EANF;IAOI,kBAAA;IACA,aAAA;EAnDJ;AACF;AAqDI;EACE,kBAAA;AAnDN;AAqDM;EAHF;IAII,mBAAA;EAlDN;AACF;;AAwDA;EACE,eAAA;EACA,aAAA;EACA,oBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;AArDF;AAuDE;EAVF;IAWI,4BAAA;IACA,WAAA;EApDF;AACF;AAsDE;EACE,oBAAA;EACA,qDAAA;AApDJ;AAwDE;EACE,SAAA;EACA,WAAA;AAtDJ;AAwDI;EAJF;IAKI,YAAA;IACA,aAAA;IACA,YAAA;IACA,eAAA;EArDJ;AACF;AAwDE;EACE,SAAA;EACA,UAAA;AAtDJ;AAwDI;EAJF;IAKI,YAAA;IACA,aAAA;IACA,YAAA;IACA,eAAA;EArDJ;AACF;AAwDE;EACE,SAAA;EACA,SAAA;EACA,2BAAA;AAtDJ;AAwDI;EALF;IAMI,YAAA;IACA,aAAA;IACA,YAAA;IACA,eAAA;IACA,eAAA;EArDJ;AACF;AAwDE;EACE,YAAA;EACA,WAAA;AAtDJ;AAwDI;EAJF;IAKI,eAAA;IACA,aAAA;IACA,YAAA;IACA,eAAA;EArDJ;AACF;AAwDE;EACE,YAAA;EACA,UAAA;AAtDJ;AAwDI;EAJF;IAKI,eAAA;IACA,aAAA;IACA,YAAA;IACA,eAAA;EArDJ;AACF;AAwDE;EACE,YAAA;EACA,SAAA;EACA,2BAAA;AAtDJ;AAwDI;EALF;IAMI,eAAA;IACA,aAAA;IACA,YAAA;IACA,eAAA;IACA,eAAA;EArDJ;AACF;;AA0DA;EACE;IACE,UAAA;IACA,8BAAA;EAvDF;EAyDA;IACE,UAAA;IACA,wBAAA;EAvDF;AACF;AA2DA;EACE,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EAEA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EAEA,eAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;AA3DF","sourcesContent":["// Dark theme support\n.dark .paylixecommerce-notification {\n  background: rgba(15, 23, 42, 0.95);\n  border-color: rgba(71, 85, 105, 0.4);\n  \n  &.info {\n    background: rgba(88, 28, 135, 0.15);\n    border-color: rgba(139, 92, 246, 0.3);\n    \n    .paylixecommerce-notification-icon {\n      background: rgba(88, 28, 135, 0.2);\n      svg {\n        color: #C4B5FD !important;\n        \n        * {\n          stroke: #C4B5FD !important;\n        }\n      }\n    }\n    \n    .paylixecommerce-notification-title {\n      color: #E2E8F0;\n    }\n    \n    .paylixecommerce-notification-message {\n      color: #CBD5E1;\n    }\n  }\n  \n  &.success {\n    background: rgba(5, 150, 105, 0.15);\n    border-color: rgba(34, 197, 94, 0.3);\n    \n    .paylixecommerce-notification-icon {\n      background: rgba(5, 150, 105, 0.2);\n      svg {\n        color: #6EE7B7 !important;\n        \n        * {\n          stroke: #6EE7B7 !important;\n        }\n      }\n    }\n    \n    .paylixecommerce-notification-title {\n      color: #E2E8F0;\n    }\n    \n    .paylixecommerce-notification-message {\n      color: #CBD5E1;\n    }\n  }\n  \n  &.warning {\n    background: rgba(249, 115, 22, 0.15);\n    border-color: rgba(251, 146, 60, 0.3);\n    \n    .paylixecommerce-notification-icon {\n      background: rgba(249, 115, 22, 0.2);\n      svg {\n        color: #FDBA74 !important;\n        \n        * {\n          stroke: #FDBA74 !important;\n        }\n      }\n    }\n    \n    .paylixecommerce-notification-title {\n      color: #E2E8F0;\n    }\n    \n    .paylixecommerce-notification-message {\n      color: #CBD5E1;\n    }\n  }\n  \n  &.error {\n    background: rgba(220, 38, 38, 0.15);\n    border-color: rgba(248, 113, 113, 0.3);\n    \n    .paylixecommerce-notification-icon {\n      background: rgba(220, 38, 38, 0.2);\n      svg {\n        color: #FECACA !important;\n        \n        * {\n          stroke: #FECACA !important;\n        }\n      }\n    }\n    \n    .paylixecommerce-notification-title {\n      color: #E2E8F0;\n    }\n    \n    .paylixecommerce-notification-message {\n      color: #CBD5E1;\n    }\n  }\n  \n  // Dark mode close button\n  .paylixecommerce-notification-close {\n    color: #94A3B8;\n    \n    &:hover {\n      background: rgba(71, 85, 105, 0.2);\n      color: #E2E8F0;\n    }\n    \n    &:focus {\n      box-shadow: 0 0 0 2px rgba(139, 92, 246, 0.5);\n    }\n  }\n}\n\n// Main notification component\n.paylixecommerce-notification {\n  position: relative;\n  background: var(--white);\n  border: 1px solid var(--black2);\n  border-radius: 0.75rem;\n  box-shadow: 0px 4px 8px -2px rgba(7, 14, 35, 0.08), 0px 2px 4px -2px rgba(7, 14, 35, 0.03);\n  font-family: 'Inter', sans-serif;\n  font-style: normal;\n  overflow: hidden;\n  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n  max-width: 100%;\n  \n  @media (max-width: 768px) {\n    border-radius: 0.5rem;\n    margin: 0 0.5rem;\n  }\n  \n  &:hover {\n    box-shadow: 0px 8px 16px -4px rgba(7, 14, 35, 0.12), 0px 4px 8px -4px rgba(7, 14, 35, 0.06);\n  }\n  \n  // Disable hover effect when no-hover class is present\n  &.no-hover:hover {\n    box-shadow: 0px 4px 8px -2px rgba(7, 14, 35, 0.08), 0px 2px 4px -2px rgba(7, 14, 35, 0.03);\n  }\n  \n  // Variant styles\n  &.info {\n    background: var(--purple0);\n    border-color: var(--purple2);\n    \n    .paylixecommerce-notification-icon {\n      background: var(--purple1);\n      svg * {\n        stroke: var(--purple6);\n      }\n    }\n    \n    .paylixecommerce-notification-title {\n      color: var(--purple9);\n    }\n    \n    .paylixecommerce-notification-message {\n      color: var(--purple7);\n    }\n  }\n  \n  &.success {\n    background: var(--green0);\n    border-color: var(--green2);\n    \n    .paylixecommerce-notification-icon {\n      background: var(--green1);\n      svg * {\n        stroke: var(--green6);\n      }\n    }\n    \n    .paylixecommerce-notification-title {\n      color: var(--green9);\n    }\n    \n    .paylixecommerce-notification-message {\n      color: var(--green7);\n    }\n  }\n  \n  &.warning {\n    background: var(--orange0);\n    border-color: var(--orange2);\n    \n    .paylixecommerce-notification-icon {\n      background: var(--orange1);\n      svg * {\n        stroke: var(--orange6);\n      }\n    }\n    \n    .paylixecommerce-notification-title {\n      color: var(--orange9);\n    }\n    \n    .paylixecommerce-notification-message {\n      color: var(--orange7);\n    }\n  }\n  \n  &.error {\n    background: var(--red0);\n    border-color: var(--red2);\n    \n    .paylixecommerce-notification-icon {\n      background: var(--red1);\n      svg * {\n        stroke: var(--red6);\n      }\n    }\n    \n    .paylixecommerce-notification-title {\n      color: var(--red9);\n    }\n    \n    .paylixecommerce-notification-message {\n      color: var(--red7);\n    }\n  }\n  \n  &-content {\n    display: flex;\n    align-items: flex-start;\n    gap: 0.75rem;\n    padding: 1rem;\n    \n    @media (max-width: 768px) {\n      gap: 0.5rem;\n      padding: 0.875rem;\n    }\n  }\n  \n  &-icon {\n    flex-shrink: 0;\n    width: 2.5rem;\n    height: 2.5rem;\n    border-radius: 0.5rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: var(--purple1);\n    \n    @media (max-width: 768px) {\n      width: 2.25rem;\n      height: 2.25rem;\n    }\n    \n    svg {\n      width: 1.125rem;\n      height: 1.125rem;\n      \n      @media (max-width: 768px) {\n        width: 1rem;\n        height: 1rem;\n      }\n    }\n  }\n  \n  &-body {\n    flex: 1;\n    min-width: 0;\n  }\n  \n  &-header {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    margin-bottom: 0.25rem;\n    gap: 1rem;\n  }\n  \n  &-title {\n    font-weight: 600;\n    font-size: 0.875rem;\n    line-height: 1.25rem;\n    color: var(--black9);\n    margin: 0;\n    flex: 1;\n    \n    @media (max-width: 768px) {\n      font-size: 0.813rem;\n      line-height: 1.125rem;\n    }\n  }\n  \n  &-close {\n    flex-shrink: 0;\n    background: transparent;\n    border: none;\n    padding: 0.125rem;\n    border-radius: 0.25rem;\n    cursor: pointer;\n    color: var(--black4);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.15s ease-in-out;\n    \n    &:hover {\n      background: var(--black1);\n      color: var(--black6);\n    }\n    \n    &:focus {\n      outline: none;\n      box-shadow: 0 0 0 2px var(--purple2);\n    }\n    \n    svg {\n      width: 1rem;\n      height: 1rem;\n    }\n  }\n  \n  &-message {\n    font-weight: 400;\n    font-size: 0.813rem;\n    line-height: 1.125rem;\n    color: var(--black6);\n    margin: 0 0 0.75rem 0;\n    \n    @media (max-width: 768px) {\n      font-size: 0.75rem;\n      line-height: 1rem;\n      margin-bottom: 0.5rem;\n    }\n    \n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n  \n  &-children {\n    margin: 0.75rem 0 0 0;\n    \n    @media (max-width: 768px) {\n      margin-top: 0.5rem;\n    }\n    \n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n  \n  &-actions {\n    display: flex;\n    gap: 0.5rem;\n    margin-top: 0.75rem;\n    flex-wrap: wrap;\n    \n    @media (max-width: 768px) {\n      margin-top: 0.5rem;\n      gap: 0.375rem;\n    }\n    \n    button {\n      font-size: 0.75rem;\n      \n      @media (max-width: 768px) {\n        font-size: 0.688rem;\n      }\n    }\n  }\n}\n\n// Toast notification positioning\n.paylixecommerce-notification-toast {\n  position: fixed;\n  z-index: 9999;\n  pointer-events: none;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  max-width: 420px;\n  width: 100%;\n  \n  @media (max-width: 768px) {\n    max-width: calc(100% - 1rem);\n    gap: 0.5rem;\n  }\n  \n  .paylixecommerce-notification {\n    pointer-events: auto;\n    animation: slideIn 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n  }\n  \n  // Position variants\n  &.top-right {\n    top: 1rem;\n    right: 1rem;\n    \n    @media (max-width: 768px) {\n      top: 0.75rem;\n      right: 0.5rem;\n      left: 0.5rem;\n      max-width: none;\n    }\n  }\n  \n  &.top-left {\n    top: 1rem;\n    left: 1rem;\n    \n    @media (max-width: 768px) {\n      top: 0.75rem;\n      right: 0.5rem;\n      left: 0.5rem;\n      max-width: none;\n    }\n  }\n  \n  &.top-center {\n    top: 1rem;\n    left: 50%;\n    transform: translateX(-50%);\n    \n    @media (max-width: 768px) {\n      top: 0.75rem;\n      right: 0.5rem;\n      left: 0.5rem;\n      transform: none;\n      max-width: none;\n    }\n  }\n  \n  &.bottom-right {\n    bottom: 1rem;\n    right: 1rem;\n    \n    @media (max-width: 768px) {\n      bottom: 0.75rem;\n      right: 0.5rem;\n      left: 0.5rem;\n      max-width: none;\n    }\n  }\n  \n  &.bottom-left {\n    bottom: 1rem;\n    left: 1rem;\n    \n    @media (max-width: 768px) {\n      bottom: 0.75rem;\n      right: 0.5rem;\n      left: 0.5rem;\n      max-width: none;\n    }\n  }\n  \n  &.bottom-center {\n    bottom: 1rem;\n    left: 50%;\n    transform: translateX(-50%);\n    \n    @media (max-width: 768px) {\n      bottom: 0.75rem;\n      right: 0.5rem;\n      left: 0.5rem;\n      transform: none;\n      max-width: none;\n    }\n  }\n}\n\n// Animation\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-0.5rem);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n// Color variables for different variants (following existing pattern)\nhtml .paylixecommerce-notification {\n  --green9: #065F46;\n  --green8: #047857;\n  --green7: #059669;\n  --green6: #10B981;\n  --green5: #34D399;\n  --green4: #6EE7B7;\n  --green3: #A7F3D0;\n  --green2: #D1FAE5;\n  --green1: #ECFDF5;\n  --green0: #F0FDF4;\n  \n  --orange9: #9A3412;\n  --orange8: #C2410C;\n  --orange7: #EA580C;\n  --orange6: #F97316;\n  --orange5: #FB923C;\n  --orange4: #FDBA74;\n  --orange3: #FED7AA;\n  --orange2: #FEEBC8;\n  --orange1: #FEF3E2;\n  --orange0: #FFFBEB;\n  \n  --red9: #991B1B;\n  --red8: #DC2626;\n  --red7: #EF4444;\n  --red6: #F87171;\n  --red5: #FCA5A5;\n  --red4: #FECACA;\n  --red3: #FEE2E2;\n  --red2: #FEEAEA;\n  --red1: #FEF2F2;\n  --red0: #FEF7F7;\n} "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
